"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const KeuzeTarief_1 = tslib_1.__importDefault(require("../enums/KeuzeTarief"));
class GetTariffsProduct extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '8716879000004',
        description: `The grid operator ean.
    This has no influence on the tariffs, only on which disclaimer the user gets.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetTariffsProduct.prototype, "gridOperatorEAN", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '8742010202112',
        description: `States what kind of installation the address has.
    For example if you have 3x25 ampere or only 1x80.
    This heavily influences the tariffs you receive.
    You find the result under "Netbeheerder kosten".`,
    }),
    tslib_1.__metadata("design:type", String)
], GetTariffsProduct.prototype, "captarEAN", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '14328',
        description: 'Influences the supply rates. Different campaigns have different rates.',
    }),
    tslib_1.__metadata("design:type", String)
], GetTariffsProduct.prototype, "campaignId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.DurationInYears)),
    (0, base_models_1.Docs)({
        example: base_models_1.DurationInYears.FLEX,
        description: 'The duration of the contract. Influences the proposition that will be chosen.',
    }),
    tslib_1.__metadata("design:type", String)
], GetTariffsProduct.prototype, "duration", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(KeuzeTarief_1.default)),
    (0, base_models_1.Docs)({
        example: KeuzeTarief_1.default.BUDGET,
        description: 'Tied in to with the campaign. Describes the type of contract the customer picked',
    }),
    tslib_1.__metadata("design:type", String)
], GetTariffsProduct.prototype, "keuzeTarief", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: 'G_H_B',
        description: `Describes the type of installation (G or E).
    The second part describes if it is a household (H) or not (M).
    The last part describes the type of contract (Basis, Basis Duurzaam), this is not the same as 'keuzeTarief'.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetTariffsProduct.prototype, "commodityProduct", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/\d{4}-\d{2}-\d{2}/),
    (0, base_models_1.Docs)({
        example: '2022-12-23',
        description: 'When the contract will start, the tariffs will be fetched that are valid for this date.',
    }),
    tslib_1.__metadata("design:type", String)
], GetTariffsProduct.prototype, "startDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/\d{4}-\d{2}-\d{2}/),
    (0, base_models_1.Docs)({
        example: '2022-12-01',
        description: `Used to check if the given campaign is valid for this period.
    Is usually the first of the next month.
    For "Zeker" campaigns, the tariff date must match with the start of the proposition valid date.
    For all other types of contract the tariff date should be between the start and end of when a proposition is valid.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetTariffsProduct.prototype, "tariffDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        example: false,
        description: `Also known as complex bepaling.
      This information is maintained by EDSN.
      For tariffs, if residential is true and complex is false, that address will get belasting voordeel.
      Defaults to false.`,
    }),
    tslib_1.__metadata("design:type", Boolean)
], GetTariffsProduct.prototype, "complex", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        example: true,
        description: `If true it means that is a "regular" home.
    Defaults to true.
    The combination residential and complex should be true and false, if you think it should receive belasting voordeel.`,
    }),
    tslib_1.__metadata("design:type", Boolean)
], GetTariffsProduct.prototype, "residential", void 0);
exports.default = GetTariffsProduct;
